import React, { useEffect, useMemo, useState } from 'react'
import ReactDOM from 'react-dom'
import { menuStructure } from '../../../constants/menuStructure'
import styles from './Menu.module.css'
import MenuItem from './Item'
import MobileMenuItem from './MobileItem'
import { connect, useSelector } from 'react-redux'
import { Col, Row } from 'react-bootstrap'
import menuIcon from '../../../img/icons/menu.png'
import { BASE_URL, MAX_RETRIES } from '../../../constants/api'
import { getActualMenuStructure } from '../../../utils/menuStructure'

const mapStateToProps = ({ auth: { data } }) => ({
  authData: data,
})
const Menu = ({ authData }) => {
  
  const {data, reports_access} = useSelector(state => state.auth);
  
  const [menuOpen, setMenuOpen] = useState(false);
  const [withShare, setWithShare] = useState(false);

  useEffect(() => {  
    const checkPermission = async () => {
      for (let i = 1; i <= MAX_RETRIES; i++) {
        const res = await fetch(`${BASE_URL}/?action=consolidated.access&base=cons&format=json&token=Обмен файлами&mode=Режимы&access=2&login=${authData.login}&pass=${authData.pass}`)
        const data = await res.json()
        const { Result, Message, Data } = data.Answer
        const withShare = Result !== 'Error'
        setWithShare(withShare)
        if (withShare) return;
      }
    }
    checkPermission()
  }, [])

  const actualMenu = useMemo(() => getActualMenuStructure(reports_access, withShare, data?.login), [reports_access, withShare]) 

  return (
    <>
      <div className={styles.container}>
        <Row noGutters>
          {actualMenu.map((item, index) => (
            <Col key={index}>
              <MenuItem authData={authData} {...item} />
            </Col>
          ))}
        </Row>
      </div>

      <button onClick={() => setMenuOpen(!menuOpen)} className={styles.mobileMenuButton}>
        <img src={menuIcon} alt='' />
      </button>
      {menuOpen && (
        <div className={styles.mobile}>
          {actualMenu.map((item, index) => (
            <div key={`menuitem${index}`}>
              <MobileMenuItem authData={authData} onSelectItem={() => setMenuOpen(false)} {...item} />
            </div>
          ))}
        </div>
      )}
    </>
  )
}

export default connect(mapStateToProps)(Menu)
